import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseReadService } from "./abstract/base-read.service";
import { League, LeagueRepository } from "./leagues.repository";

const API = '/api/leagues';

@Injectable({ providedIn: 'root' })
export class LeaguesService extends BaseReadService<League> {

  constructor(
    http: HttpClient,
    repo: LeagueRepository
  ) {
    super(API, http, repo);
  }
}